export enum Permission {
    APPROVE_AGENTS = 'APPROVE_AGENTS'
}
